import { useApi } from '~/composables/useApi';

/** saveEvalEnd.do는 MultipartHttpServletRequest를 사용하므로 multipart(FormData)로 전송 */
const toFormData = (params: URLSearchParams) => {
  const formData = new FormData();
  params.forEach((value, key) => {
    formData.append(key, value);
  });
  return formData;
};

export const useEvaluateCommonApi = () => {
  // 평가군 조회
  const fetchEvalGrpList = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/selectEvalGrpList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 평가 설정 기본값
  const fetchEvalConfig = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/evalConfig.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 평가대상자 설정 기간, 역량평가 최종결과 조회
  const fetchTargetMngData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectTargetMngData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 평가대상자, 평가점수평가 목록 조회
  const fetchEvalTargetList = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/evalTargetList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 평가의견 조회
  const fetchEvalOpinionList = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/evalOpinionList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 시뮬레이션 조회 여부
  const fetchSimulationData = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/simuDataList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 시뮬레이션 결과 저장
  const fetchSaveResultSimulation = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/saveResultSimulation.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 평가완료 여부와 평가완료 가능여부를 체크하여 평가완료저장 (서버: MultipartHttpServletRequest)
  const fetchSaveEvalEnd = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/saveEvalEnd.do', {
      method: 'POST',
      body: toFormData(params)
    });
  };

  // 평가 포기/취소 (성과·역량 공통)
  const fetchGiveupEval = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/hreEvalCommon/giveupEval.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // 피드백 기본 데이터 조회
  const fetchFeedbackBase = (params: URLSearchParams) => {
    return useApi('/api/hre/eval/performEval/selectFeedbackBase.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // IDP 활동 데이터 조회
  const fetchSelectActivityDatas = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/selectActivity_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // IDP 데이터 조회
  const fetchIdpData = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/selectIdpData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // IDP 계획 데이터 조회
  const fetchIdpPlanData = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/selectPlan_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  // IDP 피드백 데이터 조회
  const fetchIdpFeedbackData = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/selectFeedback_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  /**
   * IDP 피드백 읽음처리
   *
   * 엔드포인트가 idpMng 이 아니라 taskDesc 인 것은 오타가 아니다 —
   * AS-IS 도 IDP 읽음처리에 이 주소를 쓴다 (managerDashboardList.jsp idpLogRead L7956).
   * 파라미터는 year / isMyTaskDesc / searchUserId 로 IDP 조회(findYear·evalTargetId)와 이름이 다르다.
   */
  const fetchInsertIdpFeedbackRead = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/taskDesc/insertFeedbackRead_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  /**
   * IDP 피드백 저장 (등록/수정 공용)
   *
   * AS-IS managerDashboardList.jsp insertIdpFeedback L7976 / updateFeedback
   * params: year, content, ratings, userId(대상자) [, feedbackId → 있으면 수정]
   * 응답: dataVO (저장된 피드백 1건)
   */
  const fetchSaveIdpFeedback = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/insertFeedback.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  /**
   * IDP 피드백 삭제
   * params: year, feedbackId, userId(대상자)
   */
  const fetchDeleteIdpFeedback = (params: URLSearchParams) => {
    return useApi('/api/hcm/obj/idpMng/deleteFeedback.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
  };

  return {
    fetchEvalGrpList,
    fetchEvalConfig,
    fetchTargetMngData,
    fetchEvalTargetList,
    fetchEvalOpinionList,
    fetchSimulationData,
    fetchSaveResultSimulation,
    fetchSaveEvalEnd,
    fetchGiveupEval,
    fetchFeedbackBase,
    fetchSelectActivityDatas,
    fetchIdpData,
    fetchIdpPlanData,
    fetchIdpFeedbackData,
    fetchInsertIdpFeedbackRead,
    fetchSaveIdpFeedback,
    fetchDeleteIdpFeedback,
  };
};
